import { api, apiWithRefreshToken } from '.';

type GetListOrderProps = {
  productType?: string;
  orderStatus?: string;
  orderCategory?: string;
  page?: number;
  size?: number;
  accessToken?: string;
};
type GetListParams = {
  productType?: string;
  orderStatus?: string;
  orderCategory?: string;
  page?: number;
  size?: number;
};

const getFilterType = async (accessToken) => {
  try {
    const resp = apiWithRefreshToken.get(
      'saphybris-proxy/v1/saphybris/orders/filter/product-types',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getFilterStatus = async (accessToken) => {
  try {
    const resp = apiWithRefreshToken.get(
      'saphybris-proxy/v1/saphybris/orders/filter/order-status',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return resp;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getListOrder = async ({
  productType,
  orderStatus,
  orderCategory,
  page,
  size,
}: GetListOrderProps) => {
  let params: GetListParams = {
    productType,
    orderStatus,
    orderCategory,
  };

  if (size) {
    params = {
      ...params,
      page: page,
      size: size,
    };
  }

  const response = await apiWithRefreshToken.get('api/order-tracking/orders', {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    params,
  });

  return response;
};

const getListOrderFromServer = async ({
  productType,
  orderStatus,
  orderCategory,
  page,
  size,
  accessToken,
}: GetListOrderProps) => {
  let params: GetListParams = {
    productType,
    orderStatus,
    orderCategory,
  };

  if (size) {
    params = {
      ...params,
      page: page,
      size: size,
    };
  }

  try {
    const response = await apiWithRefreshToken.get(
      'saphybris-proxy/v1/saphybris/my-account/purchase-orders',
      {
        params,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getOrderDetail = async ({ orderNo }: { orderNo: string }) => {
  const response = await apiWithRefreshToken.get(`api/order-tracking/orders/${orderNo}`, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });

  return response.data;
};

const getDetailOrderFromServer = async ({
  accessToken,
  orderNo,
}: {
  accessToken: string;
  orderNo: string;
}) => {
  try {
    const response = await apiWithRefreshToken.get(
      `/saphybris-proxy/v1/saphybris/orders/${orderNo}`,
      {
        params: {
          mode: 'all',
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const downloadEReceipt = async (orderNo) => {
  const response = await apiWithRefreshToken.get(
    `api/order-tracking/download-e-receipt/${orderNo}`,
    {
      baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    }
  );

  return response.data;
};

const getOfflineOrderDetail = async ({ orderNo }) => {
  try {
    const response = await api.get('saphybris-proxy/v1/saphybris/tracking-unit-service', {
      params: {
        orderNo,
        isPushNotif: false,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const syncO2OTrackingOrder = async ({ accessToken }: { accessToken: string }) => {
  try {
    const response = await apiWithRefreshToken.get(
      'saphybris-proxy/v1/saphybris/saveOrderOffline2Online',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const updateGTMSent = async (payload: string) => {
  const response = await apiWithRefreshToken.put(`api/order-tracking/update-gtm-sent`, payload, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });

  return response.data;
};

export default {
  getFilterType,
  getFilterStatus,
  getListOrder,
  getListOrderFromServer,
  getOrderDetail,
  downloadEReceipt,
  getOfflineOrderDetail,
  getDetailOrderFromServer,
  syncO2OTrackingOrder,
  updateGTMSent,
};
